import React from 'react'
import USDefaultTemplate from 'src/components/template/us'
import { networkLogos } from 'src/constants/networkLogos'

export default (props) => {
  return (
    <USDefaultTemplate
      location={props.location}
      video="https://assets.fubo.tv/marketing/lp/videos/compressed/MSG_Generic_LP_30s.mp4"
      staticAnnotation={networkLogos.msg}
      title="Watch MSG Networks live"
      subtitle="See the Knicks, Rangers, Islanders, Devils, Sabres & more. Regional restrictions apply."
      networkSet="sports"
      customNetworks={['msg']}
    />
  )
}
